import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function Hero() {
  const [currentPrice, setCurrentPrice] = useState(37);
  useEffect(() => {
    const isExpired = document.cookie.split('; ').find(row => row.startsWith('priceExpired='))?.split('=')[1] === 'true';
    if (isExpired) {
      setCurrentPrice(97);
    }
  }, []);
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden px-4 py-20" data-id="element-109">
      {/* Animated background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-navy via-navy-light to-navy-dark" data-id="element-110">
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.3, 0.5, 0.3]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-0 right-0 w-96 h-96 bg-gold/20 rounded-full blur-3xl" data-id="element-111" />
        <motion.div animate={{
        scale: [1.2, 1, 1.2],
        opacity: [0.2, 0.4, 0.2]
      }} transition={{
        duration: 10,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute bottom-0 left-0 w-96 h-96 bg-gold/10 rounded-full blur-3xl" data-id="element-112" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto" data-id="element-113">
        {/* Headline */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-center mb-6 md:mb-8" data-id="element-114">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="font-heading font-black text-4xl md:text-5xl lg:text-6xl leading-tight mb-4 md:mb-6" data-id="element-115">
            Gana Tu Primer <span className="text-gold" data-id="element-116">$1,000</span> Esta Semana
            Vendiendo Sitios Web a Negocios Locales
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="font-body text-lg md:text-xl text-gray-300 mb-4" data-id="element-117">
            (La IA los Construye en Minutos. Tú Solo Haces la Llamada.)
          </motion.p>
        </motion.div>

        {/* Hero Image */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="relative mb-6 md:mb-10" data-id="element-118">
          <motion.div initial={{
          scale: 0.95
        }} animate={{
          scale: 1
        }} transition={{
          duration: 1,
          delay: 0.8
        }} className="relative z-10 w-full rounded-lg shadow-2xl overflow-hidden" style={{
          padding: '56.25% 0 0 0',
          position: 'relative'
        }} data-id="element-119">
            <iframe src="https://player.vimeo.com/video/1177040592?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%'
          }} title="AI WEBSITE TESTIMONIO" data-id="element-120" />
          </motion.div>
          <div className="absolute inset-0 bg-gradient-to-t from-navy via-transparent to-transparent rounded-lg pointer-events-none" data-id="element-121" />
        </motion.div>

        {/* Copy and CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1
      }} className="text-center" data-id="element-122">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 1.2
        }} className="font-body text-base md:text-lg text-gray-400 mb-6 md:mb-8 max-w-3xl mx-auto" data-id="element-123">
            Uno de nuestros miembros contactó 7 negocios en su primera semana.
            Cerró 3. Ganó $1,050. No sabía nada de diseño web. Tú tampoco
            necesitas saberlo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 1.4
        }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-124">
            <motion.a href="/checkout" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="group bg-gold hover:bg-gold-light text-navy font-heading font-bold text-lg px-8 py-4 rounded-lg shadow-xl transition-all duration-300 flex items-center justify-center gap-2" data-id="element-125">
              Quiero Acceso por ${currentPrice}
              <ArrowRightIcon className="h-5 w-5 group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-126" />
            </motion.a>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 1.6
        }} className="font-body text-sm text-gray-500 mt-6" data-id="element-127">
            (VIDEO DE VENTAS AQUÍ)
          </motion.p>
        </motion.div>
      </div>
    </section>;
}